export const AWS_SQS_MODULE_OPTIONS = Symbol('AWS_SQS_MODULE_OPTIONS');
export const AWS_SQS_QUEUE_PROVIDERS = Symbol('AWS_SQS_QUEUE_PROVIDERS');
export const AWS_SQS_MESSAGE_HANDLER = Symbol('AWS_SQS_MESSAGE_HANDLER');
export const AWS_SQS_QUEUE = 'AWS_SQS_QUEUE';
